export default __webpack_public_path__ + "af2001f1bc2b79746c42a48f7b6cb1a7.png";